import React, { useEffect } from 'react';
import { Stack } from '@mui/material';
import { BannerDescription } from 'new/elements/BannerDescription';
import { ScreenComponent } from 'new/routes/RouterManager';
import { ROUTE_REDESIGN } from 'js/constants/pathnames';
import { ROUTE_AI_MCP_FLOWS } from 'new/constants/pathnames';
import MCPFlowsContainer from 'new/components/mcpFlows/MCPFlowsContainer';
import { ModalMoveToProject } from 'new/elements/ModalMoveToProject';
import { useHistory, useLocation } from 'react-router-dom';
import { useAppContext } from 'new/hooks/useAppContext';
import styles from './MCPFlowsScreen.module.scss';

export const MCPFlowsScreen: ScreenComponent<Record<string, never>> = () => {
  const location = useLocation();
  const history = useHistory();
  const { setCurrentSlug } = useAppContext();

  // The URL-derived fallback renders this as "Mcp-flows"; screenConfig.header is
  // not read because AI screens are not in the router registry.
  useEffect(() => {
    setCurrentSlug('MCP Flows');
  }, [setCurrentSlug]);

  return (
    <Stack className={styles.container}>
      <BannerDescription
        title="MCP Flows"
        description="Flows that power the MCP servers you build in MCP Studio."
      />
      <div className={styles.tabContent}>
        <MCPFlowsContainer
          match={{
            params: {},
            isExact: true,
            path: location.pathname,
            url: location.pathname + location.search,
          }}
          location={location}
          history={history}
          withHeader={false}
          disableProjectView={true}
        />
      </div>
    </Stack>
  );
};

MCPFlowsScreen.displayName = 'MCPFlowsScreen';

MCPFlowsScreen.screenConfig = {
  path: `${ROUTE_REDESIGN}${ROUTE_AI_MCP_FLOWS}`,
  domain: 'ai',
  header: {
    title: 'MCP Flows',
    slugTitle: 'MCP Flows',
  },
  screenName: 'MCPFlows',
  modals: [ModalMoveToProject],
};
